// Registry of path -> dynamic import() preloader for lazy-loaded routes
// (see vite.config.js's manualChunks comment and each feature's routes.jsx
// for why routes are lazy in the first place). A route's own lazy() import
// only fires when its element is about to render, so the first navigation
// to a route always pays for its chunk's network fetch inside the Suspense
// fallback — noticeable as a "flash then wait" on the very first visit to
// a given route in a session. Calling the same import() early (e.g. on
// sidebar hover/focus, well before the click) warms the browser's module
// cache, since a dynamic import for an already-fetched specifier resolves
// from cache instead of re-fetching — by the time navigation actually
// happens, the chunk is already there or in flight.
//
// Feature route files opt in by calling registerRoutePreloader for the
// routes they want warmable; not every route needs to.
const preloadersByPath = new Map();

export const registerRoutePreloader = (path, preload) => {
  if (!path || typeof preload !== "function") return;
  preloadersByPath.set(path, preload);
};

const preloadedPaths = new Set();

export const preloadRoute = (path) => {
  if (!path || preloadedPaths.has(path)) return;
  const preload = preloadersByPath.get(path);
  if (!preload) return;
  preloadedPaths.add(path);
  preload().catch(() => {
    // A failed prefetch (offline, or a stale chunk hash after a redeploy)
    // isn't fatal — the real navigation's own Suspense boundary retries the
    // import and surfaces any error normally. Allow a later hover to retry.
    preloadedPaths.delete(path);
  });
};
